<template>
  <div class="replaceClass">
    <van-pull-refresh v-model="refreshing" loading-text="加载中..." @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" :offset="20" @load="onLoad" v-if="noData">
        <div class="card" v-for="(item, index) in orderList" :key="index">
          <div class="card-header">
            <div class="left">{{ filterOrderType(item.changeStatus) }}</div>
            <div class="right">换课</div>
            <!-- <div class="right">
              {{
                Number(item.changeAfterType) === 1
                  ? '换课退差'
                  : Number(item.changeAfterType) === 2
                  ? '换课补差'
                  : Number(item.changeAfterType) === 3
                  ? '换课不退不补'
                  : ''
              }}
            </div> -->
          </div>
          <ul>
            <li class="card-body" v-for="(ite, ind) in item.toProductInfoList" :key="ind" @click="courseDetails(item.changeNo)">
              <div class="public">
                <div class="text">
                  <p class="name"><i v-if="ite.productName.substr(0,1)=='【'" class="title-special-processing" />{{ ite.productName }}</p>
                </div>
                <span class="pice">¥
                  {{
                    ite.productAmount
                  }}</span>
              </div>
            </li>
          </ul>
          <div class="card-footer">
            <div class="pay">
              <span>售后时间 {{ item.createTime }}</span>
              <!-- 退差 -->
              <div class="money" v-if="Number(item.changeAfterType) === 1">
                <p>应退差价：</p>
                <p class="pice">¥ {{ item.refundAmount }}</p>
              </div>
              <!--补差-->
              <div class="money" v-if="Number(item.changeAfterType) === 2">
                <p>
                  {{
                    Number(item.changeStatus) === 3 ||
                    Number(item.changeStatus) === 5 ||
                    Number(item.changeStatus) === 8
                      ? '应补差价：'
                      : Number(item.changeStatus) === 4
                      ? '实补差价：'
                      : ''
                  }}
                </p>
                <p class="pice">¥ {{ item.fillAmount }}</p>
              </div>
            </div>
            <div class="button" v-if="Number(item.changeStatus) === 3">
              <div class="add-address" @click="payment(item.changeNo)">
                立即支付
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <EmptyData :emptyName="'noIndent'" v-else />
    </van-pull-refresh>
  </div>
</template>

<script>
import EmptyData from '@/components/emptyData/emptyData.vue';
import { reqReplaceList } from '@/api/personal/returnClass';
import { orderType } from '../returnClassTools';

export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: true, // 下拉刷新
      noData: true, // 无数据时状态
      orderTotal: 0,
      orderList: [],
      orderParam: {
        pageNum: 1,
        pageSize: 5,
        status: '',
      },
    };
  },

  components: {
    EmptyData,
  },

  computed: {},

  mounted() { },

  created() {
    this.replaceList();
  },
  methods: {
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      if (this.orderList.length >= this.orderTotal) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.orderParam.pageNum += 1;
        this.replaceList();
      }
    },
    // 下拉刷新
    onRefresh() {
      this.refreshing = false;
      this.clearOrderList();
    },
    // 清除缓存重新请求
    clearOrderList() {
      this.orderList = [];
      this.orderParam.pageNum = 1;
      this.loading = false;
      this.finished = false;
      this.replaceList();
    },
    async replaceList() {
      try {
        this.loading = true; // 加载状态
        const res = await reqReplaceList(this.orderParam);
        if (res.code === 0) {
          this.orderList.push(...res.data.data);
          this.orderTotal = res.data.total;
          this.loading = false;
          if (this.orderTotal > 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
          if (this.orderList.length >= this.orderTotal) {
            // 如果没有数据需要加载了就显示没有更多了
            this.finished = true;
          }
        } else {
          this.$toast(`请求异常！${res.msg}`);
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    // 立即支付
    payment(orderNo) {
      if (this.$root.$data.isApp) {
        // type = '1'表示退换课来源
        this.$sendToApp('payCenter', { orderNo, type: '1' }, false);
        return;
      }
      this.$router.push({
        path: '/cashier',
        query: { orderNo, source: 1 },
      });
    },
    // 判断订单状态
    filterOrderType(status) {
      return orderType(status);
    },
    // 详情页
    courseDetails(orderNo) {
      this.$router.push({ path: '/replaceClassDetail', query: { orderNo } });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/style/returnClass.scss';
::v-deep .van-list__loading {
  width: 100px;
  height: 100px;
  margin: 50% auto;
  line-height: 100px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 10px;
}
::v-deep .van-loading__text {
  color: #fff;
}
</style>
